@if (availableStaffForLocation) {
  <div>
    <p>{{'LOCATION_ACCESS_RIGHT_INFORMATION' |translate}}</p>
    <form [formGroup]="locationStaffEditForm" (ngSubmit)="formSubmitSubject.next()">
      <div class="form-group">
        <mat-selection-list formControlName="selectedStaffForLocation" dense="true">
          @for (staff of availableStaffForLocation; track staff) {
            <mat-list-option [value]="staff.id">
              {{staff.fullName}} ({{staff.id}})
            </mat-list-option>
          }
        </mat-selection-list>
      </div>
      <div class="form-group">
        @if (updateSuccess) {
          <div class="alert alert-success">
            {{'LOCATION_UPDATE_SUCCESS' |translate}}
          </div>
        }
        @if (updateError) {
          <div class="alert alert-danger">
            {{'ERROR' |translate}}
          </div>
        }
        <button [disabled]="locationStaffEditForm.pristine" type="submit" class="btn btn-outline-primary gray-bg mr-1"><span
        class="fa-light fa-floppy-disk"></span> {{'SAVE' |translate}}</button>
      </div>
    </form>
  </div>
}
